import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SubmissionError } from "redux-form";
import ReactTimeout from "react-timeout";

import * as downloaderActions from "../../utils/downloader/downloaderActions";
import * as dataActions from "../../utils/data/dataActions";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { downloaderEnums } from "../../utils/downloader/downloaderEnums";
import { getS3Informations } from "./environmentProperties";
import simpleFetch from "../../../utils/simpleFetch";
import { VISUALIZED, NOT_VISUALIZED } from "./enums/invoiceVisualizeStatusType";

const S3_BUCKET = getS3Informations();
class DownloadS3Button extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      downloadPath: null,
      count: 0,
      data: {},
      conditionMet: false,
      format: null,
      type: null,
      language: null,
    };

    this.download = this.download.bind(this);
    this.downloaded = this.downloaded.bind(this);
    this.createAttachment = this.createAttachment.bind(this);
    this.getVisualizingInformations = this.getVisualizingInformations.bind(
      this
    );
    this.unavailableReportToast = this.unavailableReportToast.bind(this);
    this.doVisualization = this.doVisualization.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.downloadPath) {
      if (this.props.successDownloads.length > 0) {
        let finishedDownloadObj = this.props.successDownloads.find(
          (download) => download.path == this.state.downloadPath
        );

        if (finishedDownloadObj) {
          this.setState({ downloadPath: null });
          this.downloaded();
        }
      }
      if (this.props.errorDownloads.length > 0) {
        let finishedDownloadObj = this.props.errorDownloads.find(
          (download) => download.path == this.state.downloadPath
        );

        if (finishedDownloadObj) {
          this.setState({ downloadPath: null });
          this.downloaded();
        }
      }
    }
    if (prevState.data !== this.state.data) {
      if (
        this.state.data.invoiceAttachments &&
        Object.keys(this.state.data.invoiceAttachments).length > 0
      ) {
        let invoiceAttachment = Object.values(
          this.state.data.invoiceAttachments
        ).find(
          (invoiceAttachment) =>
            invoiceAttachment.invoiceFileFormat == this.state.format &&
            invoiceAttachment.invoiceFileType == this.state.type &&
            invoiceAttachment.languageCode == this.state.language
        );
        let attachment = {
          clientMethod: "get_object",
          objectName: invoiceAttachment.objectName,
          objectPath: invoiceAttachment.objectPath,
          bucketName: S3_BUCKET.invoice.bucket_name,
          regionName: S3_BUCKET.invoice.region_name,
          invoiceAttachmentId: invoiceAttachment.invoiceAttachmentId,
        };
        this.download(attachment, true);
      }
    }
  }

  download(invoiceAttachment = null, refreshDatable=false) {
    let { model, attachment } = this.props;
    let query = {};
    if (invoiceAttachment.objectName) {
      query = invoiceAttachment;
    } else {
      query = {
        clientMethod: "get_object",
        objectPath: attachment.objectPath,
        objectName: attachment.objectName,
        regionName: attachment.regionName,
        bucketName: attachment.bucketName,
      };
    }
    const extractQueryParams = (url) => {
      if (!url) {
        return {};
      }

      return (/^[?#]/.test(url) ? url.slice(1) : url)
        .split("&")
        .reduce((params, param) => {
          let [key, value] = param.split("=");
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, " "))
            : "";
          return params;
        }, {});
    };

    return this.props.dataActions
      .getS3DataFile({ ...model, path: model.signingPath }, "", query, null)
      .then((result) => {
        if (this.props.onDownloaded && (refreshDatable && this.props.refreshDataTable || !refreshDatable)) {
          if (invoiceAttachment.objectName) {
            if(refreshDatable) {
              this.props.refreshDataTable();
            }
            this.props.onDownloaded(invoiceAttachment);
          } else {
            this.props.onDownloaded(attachment);
          }
        }
        if (result.payload.error) {
          throw new SubmissionError({
            _error: result.payload.error.data.error,
          });
        } else {
          const renderDownloader =
            !!this.props.shortLivedURL && this.props.shortLivedURL != "";
          const { shortLivedURL } = this.props;

          let url, queryParams;
          if (renderDownloader) {
            url = shortLivedURL.substr(0, shortLivedURL.indexOf("?"));
            queryParams = extractQueryParams(
              shortLivedURL.substr(shortLivedURL.indexOf("?"))
            );
          }
          this.setState({ downloadPath: this.props.shortLivedURL });
          if (!this.props.disabled) {
            this.props.downloaderActions.downloadFile(
              url,
              this.props.identifier,
              undefined,
              queryParams
            );
          } else {
            toast(
              <FormattedMessage
                id="downloader.duplicateDownload"
                values={{ file: this.props.identifier, br: <br /> }}
              />,
              {
                type: toast.TYPE.ERROR,
                autoClose: downloaderEnums.AUTO_CLOSE,
              }
            );
          }
        }
      });
  }

  createAttachment(invoiceAttachments) {
    this.setState({
      format: invoiceAttachments.format,
      type: invoiceAttachments.type,
      language: invoiceAttachments.language,
    });

    const model = {
      path: `/v1/invoices/${invoiceAttachments.invoiceId}/visualize`,
    };

    let attachment = {
      clientMethod: "get_object",
      objectName: null,
      objectPath: null,
      bucketName: S3_BUCKET.invoice.bucket_name,
      regionName: S3_BUCKET.invoice.region_name,
      invoiceAttachmentId: null,
    };

    if (invoiceAttachments.visualizeStatusType === NOT_VISUALIZED.value) {
      this.doVisualization(model, invoiceAttachments);
    } else if (
      invoiceAttachments.visualizeStatusType === VISUALIZED.value &&
      invoiceAttachments.attachments &&
      Object.keys(invoiceAttachments.attachments).length > 0
    ) {
      /**
       * If we fall in this condition, invoice attachments are visualized.
       */
      let invoiceAttachment = Object.values(
        invoiceAttachments.attachments
      ).find(
        (invoiceAttachment) =>
          invoiceAttachment.invoiceFileFormat == invoiceAttachments.format &&
          invoiceAttachment.invoiceFileType == invoiceAttachments.type &&
          invoiceAttachment.languageCode == invoiceAttachments.language
      );

      if(!invoiceAttachment) {
        toast(
          <FormattedMessage
            id="downloader.visualizationError"
          />,
          {
            type: toast.TYPE.ERROR,
            autoClose: false,
          }
        );
      }
      else {
        attachment = {
          clientMethod: "get_object",
          objectName: invoiceAttachment.objectName,
          objectPath: invoiceAttachment.objectPath,
          bucketName: S3_BUCKET.invoice.bucket_name,
          regionName: S3_BUCKET.invoice.region_name,
          invoiceAttachmentId: invoiceAttachment.invoiceAttachmentId,
        };
        this.download(attachment);
      }
    } else {
      this.doVisualization(model, invoiceAttachments);
    }
  }

  doVisualization(model, invoiceAttachments) {
      this.props.dataActions.simplePost(
        { model , data : {
          invoiceId: invoiceAttachments.invoiceId,
          formatType: invoiceAttachments.format,
          fileType: invoiceAttachments.type,
          languageCode: invoiceAttachments.language,
        }}
      );
      toast(<FormattedMessage id="toast.visualization" />, {
        type: toast.TYPE.INFO,
        autoClose: false,
      });
      this.getVisualizingInformations(invoiceAttachments.invoiceId);
  }

  getVisualizingInformations(invoiceId) {
    this.setState({ data: {}, conditionMet: false }, () =>
      this.myInterval = setInterval(() => {
        if (!this.state.conditionMet) {
          simpleFetch("GET", `/v1/invoices/${invoiceId}`, {}).then((response) => {
            if (response.invoiceVisualizeStatusType === VISUALIZED.value) {
              this.setState({ data: response, conditionMet: true });
              toast.dismiss();
              clearInterval(this.myInterval);
            }
          });
        }
      }, 5000) // 5000 milliseconds = 5 seconds
    );
  }

  downloaded() {
    return this.props.dataActions.clearS3DataFile(this.props.model);
  }

  unavailableReportToast() {
    toast(<FormattedMessage id="accountingExport.unavailable" />, {
      type: toast.TYPE.ERROR,
      autoClose: downloaderEnums.AUTO_CLOSE,
    });
  }

  render() {
    const { icon } = this.props;

    return (
      <span className="dataTable-action-button">
        <span
          ref="action"
          className={`dataTable-action-button action-icon ${
            this.props.blockButton && "disabled"
          } ${icon}`}
          onClick={
            this.props.blockButton
              ? this.unavailableReportToast
              : this.props.invoiceAttachment
              ? () => this.createAttachment(this.props.invoiceAttachment)
              : this.download
          }
        >
          {this.props.label}
        </span>
      </span>
    );
  }
}

DownloadS3Button.propTypes = {
  attachment: PropTypes.object,
  dataActions: PropTypes.object,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  model: PropTypes.object.isRequired,
  onDownloaded: PropTypes.func,
  shortLivedURL: PropTypes.string,
  identifier: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  invoiceAttachment: PropTypes.object,
  refreshDataTable: PropTypes.func,
  successDownloads: PropTypes.array,
  errorDownloads: PropTypes.array,
  downloaderActions: PropTypes.object,
  blockButton: PropTypes.bool
};

DownloadS3Button.defaultProps = {
  icon: "icon-in",
};

function mapStateToProps(state, ownProps) {
  let shortLivedURL = null;
  let model = ownProps.model.name;
  if (state.data[model]) {
    shortLivedURL = state.data[model].shortLivedURL; // Parent components always pass the model, so we can simply access the shortLivedURL from the model's store.
  }
  const downloads = state.downloader || {};
  return {
    shortLivedURL:
      !!shortLivedURL && shortLivedURL.signedUrl.length > 0
        ? shortLivedURL.signedUrl
        : null, // If current page has shortLivedURL, we set it, if not, it's equal to null.
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    downloaderActions: bindActionCreators(downloaderActions, dispatch),
  };
}

export default ReactTimeout(
  connect(mapStateToProps, mapDispatchToProps)(DownloadS3Button)
);



// WEBPACK FOOTER //
// ./src/components/common/DownloadS3Button.js